import { useEffect, useState } from 'react';
// import door from './../../assets/global/system-update.png' 

const PreLoader = ({ onFinish }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress >= 100) {
                    clearInterval(interval);
                    setTimeout(onFinish, 5000); // بعد اكتمال التحميل، أخفِ الـ PreLoader
                    return 100;
                }
                return oldProgress + 10;
            });
        }, 3000);

        return () => clearInterval(interval);
    }, [onFinish]);

    return (
        <div className="preloader-container">
            <div className="loader-ring"></div> 
            <svg className="door-icon" fill="#fff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#fff" width={25} height={25}><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>door-open</title> <path d="M30 29.25h-1.25v-25.25c-0-0.414-0.336-0.75-0.75-0.75h-6c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h5.25v25.25c0 0.414 0.336 0.75 0.75 0.75h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0zM17.853 1.26l-11.977 2c-0.357 0.062-0.626 0.37-0.626 0.74 0 0 0 0 0 0v0 25.25h-3.25c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h15.977c0.414-0 0.75-0.336 0.75-0.75v0-28c-0.001-0.414-0.337-0.75-0.751-0.75-0.043 0-0.086 0.004-0.127 0.011l0.004-0.001zM6.75 29.25v-24.615l10.477-1.749v26.364zM13.979 15.3c-0.082-0.030-0.177-0.048-0.276-0.048-0.21 0-0.401 0.079-0.545 0.209l0.001-0.001c-0.136 0.139-0.22 0.33-0.22 0.54s0.084 0.401 0.22 0.54l-0-0c0.145 0.122 0.334 0.197 0.539 0.199h0.001c0.1-0.002 0.197-0.016 0.288-0.042l-0.008 0.002c0.094-0.039 0.173-0.092 0.24-0.159v0c0.136-0.139 0.22-0.33 0.22-0.54s-0.084-0.401-0.22-0.54l0 0c-0.067-0.068-0.147-0.122-0.236-0.158l-0.005-0.002z"></path> </g></svg>
            {/* <img src={door} alt="Loading..." className="door-icon" />  */}
            <div className="progress-bar">
                <div className="progress" style={{ width: `${progress}%` }}></div> 
            </div>
        </div>
    );
};

export default PreLoader;
